import { Suspense } from "react";
import lazy from "@/utils/lazyWithReload";
import { Navigate, Outlet } from "react-router";

import { SvgIcon } from "@/components/icon";
import { CircleLoading } from "@/components/loading";

import type { AppRouteObject } from "#/router";

const ProfilePage = lazy(() => import("@/pages/management/user/profile"));
const AccountPage = lazy(() => import("@/pages/management/user/account"));

const OrganizationPage = lazy(() => import("@/pages/management/system/organization"));
const PermissioPage = lazy(() => import("@/pages/management/system/permission"));
const UserPage = lazy(() => import("@/pages/management/system/user/index"));
const RolePage = lazy(() => import("@/pages/management/system/role/index"));
const MarketingDataPage = lazy(() => import("@/pages/MarketingData/index"));
const FeaturePage = lazy(() => import("@/pages/management/system/feature/index"));
const CreditSeatPage = lazy(() => import("@/pages/management/system/credit-seat/index"));
const CreditPage = lazy(() => import("@/pages/management/system/credit/index"));
const EnterpriseManagementPage = lazy(() => import("@/pages/management/system/enterprise-management/index"));
const ClientOnboardingPage = lazy(() => import("@/pages/management/system/client-onboarding/index"));

const Blog = lazy(() => import("@/pages/management/blog"));

const roleId = localStorage.getItem("roleId")

const management: AppRouteObject = {
	order: 2,
	path: "management",
	element: (
		<Suspense fallback={<CircleLoading />}>
			<Outlet />
		</Suspense>
	),
	meta: {
		label: "sys.menu.management",
		icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="24" />,
		key: "/management",
	},
	children: [
		{
			index: true,
			element: <Navigate to={localStorage.getItem("roleId") === "6" ? "marketing-data" : "user"} replace />,
		},
		{
					path: "user",
					element: <UserPage />,
					meta: {
						label: "Users Management",
						key: "/management/user",
					},
				},
				{
					path: "role",
					element: <RolePage />,
					meta: {
						label: roleId == "1"?"Clients Management":"Departments Management",
						key: "/management/role",
					},
				},
				{
					path: "marketing-data",
					element: <MarketingDataPage/>,
					meta: {
						label:"Marketing Data",
						key: "/management/marketing-data",
					},
				},
				{
					path: "feature",
					element: <FeaturePage />,
					meta: {
						label: "Feature Management",
						key: "/management/feature",
					},
				},
				{
					path: "credit-seat",
					element: <CreditSeatPage />,
					meta: {
						label: "Credit & Seat Management",
						key: "/management/credit-seat",
					},
				},
				{
					path: "credits",
					element: <CreditPage />,
					meta: {
						label: "Credit Management",
						key: "/management/credits",
					},
				},
				{
					path: "enterprise-management",
					element: <EnterpriseManagementPage />,
					meta: {
						label: "Enterprise Management",
						key: "/management/enterprise-management",
					},
				},
				{
					path: "client-onboarding",
					element: <ClientOnboardingPage />,
					meta: {
						label: "Client Onboarding",
						key: "/management/client-onboarding",
					},
				},
		
		// {
		// 	path: "user",
		// 	meta: { label: "sys.menu.user.index", key: "/management/user" },
		// 	children: [
		// 		{
		// 			index: true,
		// 			element: <Navigate to="profile" replace />,
		// 		},
		// 		{
		// 			path: "profile",
		// 			element: <ProfilePage />,
		// 			meta: {
		// 				label: "sys.menu.user.profile",
		// 				key: "/management/user/profile",
		// 			},
		// 		},
		// 		{
		// 			path: "account",
		// 			element: <AccountPage />,
		// 			meta: {
		// 				label: "sys.menu.user.account",
		// 				key: "/management/user/account",
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	path: "system",
		// 	meta: { label: "Manage", key: "/management/system" },
		// 	children: [
		// 		// {
		// 		// 	path: "organization",
		// 		// 	element: <OrganizationPage />,
		// 		// 	meta: {
		// 		// 		label: "sys.menu.system.organization",
		// 		// 		key: "/management/system/organization",
		// 		// 	},
		// 		// },
		// 		// {
		// 		// 	path: "permission",
		// 		// 	element: <PermissioPage />,
		// 		// 	meta: {
		// 		// 		label: "sys.menu.system.permission",
		// 		// 		key: "/management/system/permission",
		// 		// 	},
		// 		// },
		// 		{
		// 			path: "user",
		// 			element: <UserPage />,
		// 			meta: {
		// 				label: "User Management",
		// 				key: "/management/system/user",
		// 			},
		// 		},
		// 		{
		// 			path: "role",
		// 			element: <RolePage />,
		// 			meta: {
		// 				label: roleId == "1"?"Organization Management":"Department Management",
		// 				key: "/management/system/role",
		// 			},
		// 		},
		// 	],
		// },
		// {
		// 	path: "blog",
		// 	element: <Blog />,
		// 	meta: { label: "sys.menu.blog", key: "/management/blog" },
		// },
	],
};

export default management;
